// Stacks objects based on area, from a bigger base to smaller top

var area = function (o) {
  if (!(o.hasOwnProperty('width') && o.hasOwnProperty('height'))) {
    throw new Error('Object needs width and height')
  }
  return o.width * o.height
}

var stack = function (wobs, secondarySort) {
  return wobs.sort(function (a, b) {
               return area(b) - area(a) || secondarySort(a, b)
             })
}

export default stack
